import get from "lodash.get";
import paths from "routes/paths";
import AbstractApiActioner from "services/cores/abstractApiActioner";

import HeatmapOccupancyActionTypes from "./types";
import HeatmapOccupancyApi from "./api";
import HeatmapOccupancyUtils from "./utils";

class HeatmapOccupancyActioner extends AbstractApiActioner {
  missingRequiredFilters(type = "default", filters) {
    if (
      !get(filters, "timestamp") ||
      !get(filters, "position") ||
      get(filters, "radius") <= 0 ||
      get(filters, "position") <= 0
    ) {
      return true;
    }

    return false;
  }
}

export default new HeatmapOccupancyActioner(
  "HeatmapOccupancy",
  HeatmapOccupancyActionTypes,
  HeatmapOccupancyApi,
  HeatmapOccupancyUtils,
  {
    paths: {
      default: paths.api.parkStatistics.dataByRadius.heatmapOccupancy,
      byAreas: null,
      byRadius: paths.api.parkStatistics.dataByRadius.heatmapOccupancy,
    },
  }
);
